import { FormInstance } from 'antd';
import React, { useMemo, useState, useEffect } from 'react';
import { components } from 'react-select';
import { FormQuestionMetaValue } from 'api/form/types';
import { Select } from 'components/atoms/select';
import {
  CountryCodeLabel,
  CountryCodeOption,
} from 'components/molecules/forms/form-fields/phone-field';
import { computePhoneNumbersList } from 'components/organisms/forms/utils';
import { Values } from './form-field-configuration';

const CountryCodeSingleValue = (props) => {
  const { data } = props;

  return (
    <components.SingleValue {...props}>
      {data.label}
      <CountryCodeLabel>{data.value}</CountryCodeLabel>
    </components.SingleValue>
  );
};

const findSelectedCountryOption = (
  countryList: {
    label: string;
    value: string;
  }[],
  selectedCountryCode: number,
) => {
  return countryList
    ? countryList.find((country) => {
        return country.value === `+${selectedCountryCode}`;
      })
    : countryList[0];
};

export const PhoneCountryCodeSelection = ({
  form,
  initialValue,
  triggerOnChange,
}: {
  form: FormInstance<Values>;
  initialValue: number;
  triggerOnChange: () => void;
}): JSX.Element => {
  const countryCodeList = useMemo(() => computePhoneNumbersList(), []);

  const [selectedCountryCodeOption, setSelectedCountryCodeOption] = useState(
    findSelectedCountryOption(countryCodeList, initialValue),
  );

  useEffect(() => {
    setSelectedCountryCodeOption(
      findSelectedCountryOption(countryCodeList, initialValue),
    );
  }, [countryCodeList, initialValue]);

  return (
    <Select
      options={countryCodeList || []}
      value={selectedCountryCodeOption}
      onChange={(v) => {
        form.setFieldsValue({
          questionMeta: {
            countryCode: parseInt(v.value.replace('+', ''), 10),
            type: FormQuestionMetaValue.Phone,
          },
        });
        setSelectedCountryCodeOption(v);
        triggerOnChange();
      }}
      components={{
        Option: CountryCodeOption,
        SingleValue: CountryCodeSingleValue,
      }}
    />
  );
};
